import Request from './request-service';

const ABSOLUTE_URL_PATTERN = /^[a-z][a-z\d+\-.]*:/i;
const DOMAIN_LIKE_PATTERN = /^[\w.-]+\.[a-z]{2,}(?::\d+)?(?:\/|$)/i;

const getApiBaseUrl = () => {
  const baseUrl = Request.buildUrl('');
  return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
};

export const normalizeDocumentImageUrl = (rawUrl: string) => {
  const url = rawUrl.trim();
  if (!url) return '';

  if (ABSOLUTE_URL_PATTERN.test(url)) return url;

  if (url.startsWith('//')) {
    const protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';
    return `${protocol}${url}`;
  }

  if (DOMAIN_LIKE_PATTERN.test(url)) return `https://${url}`;

  try {
    return new URL(url, getApiBaseUrl()).toString();
  } catch {
    return url;
  }
};
